import React from "react";

export default (props) => (
  <div className="nk-header-tools">
    <ul className="nk-quick-nav">
      {props.children}
    </ul>
  </div>
);